import * as React from "react";
import { NavLink } from "react-router-dom";
import styles from "./NavigationLink.module.scss";

export type NavigationLinkProps = {
  handleOnClick?: () => void;
  name: State.AnySubMenu;
  to: string;
  borderRight?: boolean;
  title?: string;
};

// Custom NavLink component. See README.md for more information about NavLink and React Router in general.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const NavigationLink: React.FC<NavigationLinkProps> = ({ handleOnClick, name, to, title, borderRight = true }) => (
  <NavLink
    onClick={handleOnClick}
    className={styles.NavigationLink}
    key={name}
    to={to}
    /* Detects if link is active and changes styling to activeLink */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isActive={(match: any, location: any) => {
      if (!match) {
        return false;
      }
      return location.pathname.includes(match.url);
    }}
    activeClassName={styles.activeLink}
  >
    {title || name}
  </NavLink>
);

export default NavigationLink;

